var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{ref:"yearsGridContainer",class:("years-grid years-grid--" + _vm.size),on:{"click":function($event){$event.stopPropagation();}}},_vm._l((_vm.yearOptions),function(year){return _c('div',{key:year,ref:year === _vm.selectedYear ? 'selectedYearItem' : null,refInFor:true,class:_vm.clsx('year-item', {
      'current-year': year === _vm.selectedYear,
      'today-year': _vm.isCurrentYearToday(year),
      'in-range': _vm.isInYearRange(year),
      'range-start': _vm.isYearRangeStart(year),
      'range-end': _vm.isYearRangeEnd(year),
      'is-disabled': _vm.isDisabledYear(year)
    }),attrs:{"aria-label":("Select year " + year)},on:{"click":function($event){return _vm.selectYear(year)}}},[_vm._v(" "+_vm._s(year)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }